/* 
 * DebugToolsConnector.js
 * Created on 1-dec-2016
 * @author Swen Meeuwes for &ranj
 */

import DebugToolsMenu from "../menu/DebugToolsMenu";
import DebugModuleVO from "./DebugModuleVO";

export default class DebugToolsConnector {

    constructor(injector, commands, assetLibrary, assetLoadService) {
        this._injector = injector;
        this._commands = commands;
        this._assetLibrary = assetLibrary;
        this._assetLoadService = assetLoadService;

        this._assetLoader;
        this._modules = new Map();
        this._menu;

        this._loading = false;
        this._moduleQueue = [];
    }

    configure() {
        this._loading = true;
        this._onAssetsLoadedBound = this._onAssetsLoaded.bind(this);
        this._assetLoadService.loadAssets("assets/debugtools/debugtools_assets.json");
        this._assetLoadService._loader.addEventListener("complete", this._onAssetsLoadedBound);
    }

    /*
     * Cleans up all the modules
     */
    destroy() {
        this._modules.forEach((value, key) => {
            value.destroy();
        });
        this._modules.clear();
        console.info("[Debug Tools Connector] Destroyed, cleaned up all modules");
    }


    connectModules(debugModuleVOs) {
        debugModuleVOs.forEach(vo => { this.connectModule(vo); });
    }

    /**
     * 
     * @param {DebugModuleVO} debugModuleVO 
     * @returns 
     */
     connectModule(debugModuleVO) {
        // Queue the module if the assets are being loaded
        if (this._loading) {
            this._moduleQueue.push(debugModuleVO);
            return;
        }

        this.ensureDebugMenu();

        if (this.isModuleActive(debugModuleVO)) {
            console.warn("[DebugToolsConnector] The following module is already active: ", debugModuleVO.displayName);
            return;
        }

        const constr = debugModuleVO.classConstructor;
        const module = this._injector.createInstance(constr);
        this._menu.addModule(debugModuleVO.displayName, module);
        
        //module.moduleName = moduleName;
        this._modules.set(constr, module);
        console.debug(`[Debug Tools Connector] Module '${debugModuleVO.displayName}' is now active.`);
    }

    ensureDebugMenu() {
        if (!this._menu) {
            this._menu = new DebugToolsMenu();
        }
    }

    /*
     * Checks if the module is already active.
     * @param {string} moduleName - The modules that will be checked.
     * @return {boolean} - True if the module is active.
     */
    isModuleActive(moduleVO) {
        return this._modules.has(moduleVO.classConstructor);
    }

    _onAssetsLoaded() {
        this._assetLoadService._loader.removeEventListener("complete", this._onAssetsLoadedBound);
        this._loading = false;

        console.info("[Debug Tools Connector] Done loading assets.");

        // Load modules that were queued, because the assets were being loaded
        this._loadQueuedModules();

        const debugToolsVersionObject = this._assetLibrary.getAsset("debugtools_config").version;
        const debugToolsVersion = Object.keys(debugToolsVersionObject).map(key => debugToolsVersionObject[key]);
        const debugToolsVersionString = debugToolsVersion.join('.');
        console.info(`[Debug Tools Connector] Version: ${debugToolsVersionString}`);
    }

    _loadQueuedModules() {
        if (this._loading) {
            return;
        }
        this.connectModules(this._moduleQueue);
    }
}

